import Column from '@app/components/layout/Column'
import { SafeHtml } from '@app/components/core/safeHtml/SafeHtml'
import { ContentCollapsible } from '@app/components/blocks/contentCollapsible/ContentCollapsible'
import { SectionHeader } from '../blocks/SectionHeader'

export type TextSectionType = {
  type: 'text'
  title: string
  body: string
  truncationThreshold: number
}

export const TextContentSection = ({
  title,
  body,
  truncationThreshold,
}: TextSectionType) => {
  return (
    <Column gap={0}>
      <SectionHeader title={title} />
      <ContentCollapsible truncateAfter={truncationThreshold}>
        <SafeHtml html={body} />
      </ContentCollapsible>
    </Column>
  )
}
